import { useState, useRef, useEffect } from 'react';
import { MessageSquareText, ChevronDown } from 'lucide-react';
import { useCannedResponses } from '../../hooks/useCannedResponses';

/** Dropdown that inserts a saved reply template's body via onInsert. */
export default function CannedResponsePicker({ onInsert }: { onInsert: (body: string) => void }) {
  const { responses } = useCannedResponses();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const h = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  if (responses.length === 0) return null;

  return (
    <div className="relative inline-block" ref={ref}>
      <button type="button" onClick={() => setOpen(o => !o)}
        className="inline-flex items-center gap-1.5 text-xs font-medium text-gray-600 border border-gray-200 rounded-lg px-2.5 py-1.5 hover:bg-gray-50">
        <MessageSquareText size={14} /> Insert template <ChevronDown size={13} />
      </button>
      {open && (
        <div className="absolute z-20 mt-1 w-72 max-h-72 overflow-y-auto bg-white rounded-xl shadow-dropdown border border-gray-100 animate-scale-in">
          {responses.map(r => (
            <button key={r.id} type="button"
              onClick={() => { onInsert(r.body); setOpen(false); }}
              className="w-full text-left px-3 py-2 hover:bg-gray-50 border-b border-gray-50 last:border-0">
              <div className="text-sm font-medium text-navy">{r.title}</div>
              <div className="text-xs text-gray-400 line-clamp-1">{r.body}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
